import createApi from "../utils/axiosInstance";

export const enableDMApi = async (userId) => {
  const api = createApi(true);
  const res = await api.post("/admin/messaging/enable-dm", { userId });
  return res.data;
};

export const disableDMApi = async (userId) => {
  const api = createApi(true);
  const res = await api.post("/admin/messaging/disable-dm", { userId });
  return res.data;
};

export const getDMStatusApi = async (userId) => {
  const api = createApi(true);
  const res = await api.get(`/admin/messaging/dm-status/${userId}`);
  return res.data;
};

export const getAdminConversationsApi = async () => {
  const api = createApi(true);
  const res = await api.get("/admin/messaging/conversations");
  return res.data;
};

export const getAdminMessagesApi = async (conversationId, page = 1) => {
  const api = createApi(true);
  const res = await api.get(`/admin/messaging/messages/${conversationId}?page=${page}`);
  return res.data;
};

export const markAdminConvReadApi = async (conversationId) => {
  const api = createApi(true);
  const res = await api.post(`/admin/messaging/mark-read/${conversationId}`);
  return res.data;
};

export const sendAdminMessageApi = async (payload) => {
  const api = createApi(true);
  const res = await api.post("/admin/messaging/send", payload);
  return res.data;
};

export const getAdminUploadUrlApi = async (filename, fileType) => {
  const api = createApi(true);
  const res = await api.post("/admin/messaging/upload-url", { filename, fileType });
  return res.data;
};

export const getAttachmentUrlApi = async (key) => {
  const api = createApi(true);
  const res = await api.post("/admin/messaging/attachment-url", { key });
  return res.data;
};

// Used by coach admins to fetch/send messages in their pinned super-admin conversation
// (they are the 'user' side in that conversation, so user-side endpoints are used)
export const getPinnedMessagesApi = async (page = 1) => {
  const api = createApi(true);
  const res = await api.get(`/user/messaging/messages?page=${page}`);
  return res.data;
};

export const sendPinnedMessageApi = async ({ content, attachmentUrl, attachmentType }) => {
  const api = createApi(true);
  const res = await api.post("/user/messaging/send", { content, attachmentUrl, attachmentType });
  return res.data;
};
